// extracted by mini-css-extract-plugin
export default {"user-title-cont":"UserPage_user-title-cont__SfI4s","tab-container":"UserPage_tab-container__S4thj","table-container":"UserPage_table-container__AXF3n"};